import { Directive, ElementRef, Input, AfterViewInit, OnChanges, SimpleChanges, inject } from '@angular/core';

@Directive({
  selector: '[appConvertLink]',
  standalone: false,
})
export class ConvertLinkDirective implements AfterViewInit, OnChanges {
  element = inject(ElementRef);

  regex = /(https?:\/\/[-A-Z0-9+&@#\/%=~_|()?!:,.;]*[-A-Z0-9+&@#\/%=~_|()])/gim;

  @Input() inputText: String;

  ngAfterViewInit() {
    if (!!this.inputText) {
      return;
    }

    this.sanitizerText(this.element.nativeElement.textContent);
  }

  ngOnChanges(change: SimpleChanges) {
    this.sanitizerText(change.inputText.currentValue);
  }

  sanitizerText(input) {
    const tempElement = document.createElement('div');
    tempElement.textContent = input;

    const convertedText = this.convert(tempElement.innerHTML);
    this.element.nativeElement.innerHTML = convertedText;
  }

  convert(input: String): String {
    return input.replace(this.regex, `<a href="$1" class="spen-util-link" target="_blank">$1</a>`);
  }
}
